import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/Navbar";

function App() {
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth < 800;
  const canShowLoader = typeof window !== "undefined";
  const loaderDuration = isSmallScreen ? 250 : 900;
  const [loading, setLoading] = useState(canShowLoader);

  useEffect(() => {
    if (!canShowLoader) {
      setLoading(false);
      return undefined;
    }

    const timer = setTimeout(() => setLoading(false), loaderDuration);
    return () => clearTimeout(timer);
  }, [canShowLoader, loaderDuration]);

  useEffect(() => {
    if (!canShowLoader) {
      document.body.classList.toggle("is-loading", false);
      return () => document.body.classList.toggle("is-loading", false);
    }

    document.body.classList.toggle("is-loading", loading);
    return () => document.body.classList.toggle("is-loading", false);
  }, [loading, canShowLoader]);

  return (
    <div className="App">
      {loading && (
        <div className="site-loader" role="status" aria-live="polite" aria-label="Loading">
          <div className="site-loader__inner">
            <div className="site-loader__ring" />
            <div className="site-loader__text">Loading LearnWithNova</div>
          </div>
        </div>
      )}
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;


